var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tag',{attrs:{"type":this.tableData.status(this.scope.row)}},[_vm._v(_vm._s(_vm.getText(_vm.tableData.bind)))])
}
var staticRenderFns = []

export { render, staticRenderFns }